@defer (on viewport) {
    @if (player) {
        @if (!player_badge) {
            <figure
                class="player photo"
                [style.backgroundImage]="handleBackgroundSource"
                [style.width]="handleWidth"
                [style.height]="handleHeight"
                [style.margin]="handleMargin"
            ></figure>
        }

        @if (player_badge && display_badge) {
            <div class="player badge" [style.width]="handleWidth" [style.height]="handleHeight" [style.margin]="handleMargin">
                {{ buildNameBackground() }}
            </div>
        }

        @if (display_flag) {
            <app-country-flag
                [country]="player.country"
                [width]="handleCountryFlagWidth"
                [style.bottom]="handleCountryFlagBottom"
                [style.left]="handleCountryFlagLeft"
            ></app-country-flag>
        }
    } @else if (!player) {
        <figure
            class="image"
            [class]="{ 'no-image': !this.helpers.validURL(image_url ?? '') }"
            [style.width]="handleWidth"
            [style.height]="handleHeight"
            [style.margin]="handleMargin"
            [style.borderRadius]="handleRadius"
            [style.aspect-ratio]="handleAspectRatio"
            [style.backgroundImage]="handleBackgroundSource"
        >
            <img [src]="image_url" class="article-image" onerror="this.style.display = 'none'" />
        </figure>
        @if (!image_url?.includes?.('bleachr-webclient:video_button') && type?.toLowerCase() === 'video') {
            <img class="video-button-img" src="/assets/play_button.png" [style.left]="handleVideoBtnLeft" [style.top]="handleVideoBtnTop" />
        }
    }
} @placeholder {
    <span></span>
}
